"use client";
import "./GalleryYear.scss";
import { useEffect, useState } from "react";
import { useGalleryContext } from "@/context/GalleryContext";
import { notifyError } from "@/utils/NotificationFunctions";
const SlideArrow = "../../assets/images/icons/slide-arrow.svg";
const LikeIcon = "../../assets/images/icons/like.svg";
const DislikeIcon = "../../assets/images/icons/dislike.svg";
const CommentIcon = "../../assets/images/icons/comment.svg";
const ViewsIcon = "../../assets/images/icons/views-icon.svg";
const SingleArrow = "../../assets/images/icons/arrow-chevron.svg";
const User = "../../assets/images/icons/user.svg";
import {
  getDateFormat1,
  getDifferenceDateBirth,
  getPhotoDate,
} from "@/utils/DateFormats";
import { handleImageError } from "@/utils/GalleryFunctions";
import NewComment from "@/components/NewComment/NewComment";
import PhotoComments from "@/components/PhotoComments/PhotoComments";
import Comment from "@/components/Comment/Comment";
import { usePhotoViewContext } from "@/context/PhotoViewContext";
import PhotoDiscussions from "@/components/PhotoDiscussions/PhotoDiscussions";
import NewDiscussion from "@/components/NewDiscussion/NewDiscussion";
import Discussion from "@/components/Discussion/Discussion";
import { useUserContext } from "@/context/UserContext";
import { readOnlyMessage, suspendedMessage } from "@/utils/DefaultMessages";
import { PhotoI, ReportedElementI } from "@/interfaces/galleries/Galleries";
import BaseModal from "@/components/BaseModal/BaseModal";
import ReportForm from "@/components/ReportForm/ReportForm";
import { dislike, like } from "@/services/PhotosService";
import { tagI } from "@/interfaces/Photo";
import ReplaceForm from "@/components/ReplaceForm/ReplaceForm";
import { useParams, useRouter, useSearchParams } from "next/navigation";
import Link from "next/link";
import { SubscriptionBtn } from "@/components/SubscriptionBtn/SubscriptionBtn";
import ImageModal from "@/components/Modals/ImageModal/ImageModal";
import NewTagPhoto from "./NewTagPhoto/NewTagPhoto";
import PhotoTag from "./PhotoTag/PhotoTag";
import { FiArrowLeft } from "react-icons/fi";
import ProfileLink from "@/utils/Functions/redirects/NextGotProfile";
import { formatDateTime } from "@/utils/Functions/Functionts";
import AddToCollectionModal from "@/components/Profile/AddToCollectionModal/AddToCollectionModal";

function GalleryYear() {
  const { photos, years, gallery } = useGalleryContext();
  const {
    comments,
    photo,
    author,
    year,
    index,
    loadingAuthor,
    discussions,
    tags,
    removeTag,
    totalComments,
  } = usePhotoViewContext();
  const { currentUser, userToken } = useUserContext();
  const { activeXIndex, setActiveXIndex } = useGalleryContext();

  const [subNav, setSubNav] = useState<number>(0);
  const [isTagging, setIstagging] = useState<boolean>(false);
  const [newTag, setNewTag] = useState<{ x: number; y: number } | null>(null);
  const [showTags, setShowTags] = useState<boolean>(false);
  const [report, setReport] = useState<{
    show: boolean;
    reportedElement: ReportedElementI | null;
  }>({
    show: false,
    reportedElement: null,
  });
  const [replace, setReplace] = useState<{
    show: boolean;
    replacePhoto: PhotoI | null;
  }>({
    show: false,
    replacePhoto: null,
  });
  const [fullImageModal, setFullImageModal] = useState<{
    show: boolean;
    imageUrl: string;
  }>({
    show: false,
    imageUrl: "",
  });
  const [liked, setLiked] = useState<boolean>(false);
  const [disliked, setDisliked] = useState<boolean>(false);
  const [loadingDeleteTag, setLoadingDeleteTag] = useState<boolean>(false);
  const { celebrity } = useParams();
  const searchParams = useSearchParams();
  const router = useRouter();
  const [showAddToCollection, setShowAddToCollection] =
    useState<boolean>(false);

  const checkforLikeOrDislike = () => {
    if (photo && currentUser && photo.likes.includes(currentUser?._id)) {
      setLiked(true);
      setDisliked(false);
    } else if (
      photo &&
      currentUser &&
      photo.dislikes.includes(currentUser?._id)
    ) {
      setDisliked(true);
      setLiked(false);
    }
  };

  const handleLike = async () => {
    if (photo?._id && currentUser && !photo.likes.includes(currentUser._id)) {
      let response = await like(userToken, photo?._id);
      if (response.status === "Success") {
        setLiked(true);
        setDisliked(false);
        photo.likes = [...photo.likes, currentUser._id];
        photo.dislikes = photo.dislikes.filter((e) => e !== currentUser._id);
      }
    }
  };

  const handleDislike = async () => {
    if (
      photo?._id &&
      currentUser &&
      !photo.dislikes.includes(currentUser._id)
    ) {
      let response = await dislike(userToken, photo?._id);
      if (response.status === "Success") {
        setLiked(false);
        setDisliked(true);
        photo.dislikes = [...photo.dislikes, currentUser._id];
        photo.likes = photo.likes.filter((e) => e !== currentUser._id);
      }
    }
  };
  const nextYear = (actualYear: string) => {
    const yearIndex = years.indexOf(actualYear) + 1;
    const newYear = years[yearIndex];
    if (!photos[newYear]) return;
    const newPhoto = photos[newYear][0];
    setActiveXIndex(activeXIndex + 1);
    router.push(`../${newYear}/${newPhoto._id}`);
  };

  const prevYear = (actualYear: string) => {
    const yearIndex = years.indexOf(actualYear) - 1;
    const newYear = years[yearIndex];
    if (!photos[newYear]) return;
    const newPhoto = photos[newYear][0];
    setActiveXIndex(activeXIndex - 1);
    router.push(`../${newYear}/${newPhoto._id}`);
  };

  const nextPhoto = () => {
    const yearIndex = years.indexOf(year);
    const currentYear = years[yearIndex];
    const yearPhotos = photos[currentYear];
    const yearIndexPhotos = yearPhotos.findIndex(
      (photo) => photo._id === index,
    );
    const photoIndex = yearIndexPhotos + 1;
    const upCommingPhoto = photos[currentYear][photoIndex];
    if (!upCommingPhoto) return;
    router.push(`../${year}/${upCommingPhoto._id}`);
  };
  const prevPhoto = () => {
    const yearIndex = years.indexOf(year);
    const currentYear = years[yearIndex];
    const yearPhotos = photos[currentYear];
    const yearIndexPhotos = yearPhotos.findIndex(
      (photo) => photo._id === index,
    );
    const photoIndex = yearIndexPhotos - 1;
    const upCommingPhoto = photos[currentYear][photoIndex];
    if (!upCommingPhoto) return;
    router.push(`../${year}/${upCommingPhoto._id}`);
  };

  const photoPhosition = (position: "first" | "last"): boolean => {
    if (year && index) {
      const yearIndex = years.indexOf(year);
      const currentYear = years[yearIndex];
      const yearPhotos = photos[currentYear];
      const yearIndexPhotos = yearPhotos.findIndex(
        (photo) => photo._id === index,
      );
      if (position === "first") {
        return yearIndexPhotos === 0;
      }
      if (position === "last") {
        return yearIndexPhotos === yearPhotos.length - 1;
      }
    }
    return false;
  };
  const tagInPhoto = (e: any) => {
    if (!isTagging) return;
    const parentRect = e.target.parentNode.getBoundingClientRect();
    setNewTag({
      x: e.clientX - parentRect.left,
      y: e.clientY - parentRect.top,
    });
  };

  const handleTagging = () => {
    if (!currentUser) {
      notifyError("Please Log In to tag people.");
    } else if (currentUser && currentUser.readOnly) {
      notifyError(
        readOnlyMessage(
          currentUser.readOnlyEndDate,
          currentUser.readOnlyReason,
        ),
      );
    } else if (currentUser && currentUser.isSuspended) {
      notifyError(
        suspendedMessage(
          currentUser.suspendedEndDate,
          currentUser.suspendedReason,
        ),
      );
    } else {
      setIstagging(!isTagging);
    }
  };

  const handleDeleteTag = async (tag: tagI) => {
    setLoadingDeleteTag(true);
    removeTag(tag);
  };

  useEffect(() => {
    if (!isTagging) {
      setNewTag(null);
    }
  }, [isTagging]);

  useEffect(() => {
    setIstagging(false);
    setLiked(false);
    setDisliked(false);
    setLoadingDeleteTag(false);
    checkforLikeOrDislike();
  }, [photo, tags]);

  useEffect(() => {
    setSubNav(0);
  }, [year, index]);

  useEffect(() => {
    const v = searchParams.get("v");

    if (v) {
      setSubNav(parseInt(v));
    }
  }, []);
  if (!year || !index || !gallery) return <></>;
  return (
    <div className="gallery-photo-individual-view-main-container">
      <BaseModal
        show={report.show}
        onHide={() => setReport({ show: false, reportedElement: null })}
        title={
          "Report " +
          (report.reportedElement !== null ? report.reportedElement.type : "")
        }
      >
        <ReportForm
          onHide={() => setReport({ show: false, reportedElement: null })}
          type={report.reportedElement?.type + ""}
          reportedElement={report.reportedElement}
        />
      </BaseModal>
      <ImageModal
        show={fullImageModal.show}
        onHide={() => setFullImageModal({ show: false, imageUrl: "" })}
        imageUrl={fullImageModal.imageUrl}
      />
      <BaseModal
        show={replace.show}
        onHide={() => setReplace({ show: false, replacePhoto: null })}
        title={`Replace Image`}
      >
        <ReplaceForm
          onHide={() => setReplace({ show: false, replacePhoto: null })}
          gallery={gallery}
          replacePhoto={replace.replacePhoto}
        />
      </BaseModal>
      <div className="photo-container">
        <div className="top-container">
          <Link
            href={"/" + celebrity}
            className="flex items-center gap-2 cursor-pointer orange-color"
          >
            <FiArrowLeft className="w-6 h-6" />
            Back
          </Link>
          <div className="flex items-center gap-4">
            {!isTagging ? (
              <div
                className="flex items-center gap-2 cursor-pointer"
                onClick={handleTagging}
              >
                <img src={User} /> Tag on photo
              </div>
            ) : (
              <div
                className="flex items-center gap-2 cursor-pointer"
                onClick={handleTagging}
              >
                <img src={User} /> Cancel tagging
              </div>
            )}
            <button
              className="btn linear-bg"
              onClick={() => setShowAddToCollection(true)}
            >
              + to collection
            </button>
          </div>
        </div>
        {photo && (
          <>
            <div className="flex relative gap-2 w-full max-w-[600px] mb-4">
              <img
                src={SlideArrow}
                className={`rotate-180 top-1/2 -translate-y-1/2 absolute left-4 ${
                  years.indexOf(year) === 0 ? "hidden" : ""
                }`}
                role="button"
                onClick={() => prevYear(year)}
              />
              <img
                src={SlideArrow}
                className={`absolute top-1/2 -translate-y-1/2 right-4 ${
                  years.indexOf(year) === years.length - 1 ? "d-none" : ""
                }`}
                role="button"
                onClick={() => nextYear(year)}
              />
              <div className="flex items-center w-full h-full  max-w-full max-h-full justify-center">
                <div className="flex flex-col max-w-full max-h-full p-[20px]  w-4/5">
                  <img
                    src={photo.url}
                    onClick={
                      isTagging
                        ? tagInPhoto
                        : () =>
                            setFullImageModal({
                              show: true,
                              imageUrl: photo.url,
                            })
                    }
                    className="object-contain w-full cursor-pointer"
                    alt={photo.alt}
                    draggable={false}
                  />
                  <div className="bg-black gap-2 p-2 w-full md:p-4 grid md:grid-cols-2">
                    <p style={{ fontSize: 12 }}>
                      Copyright: {photo.copyright || "NN"}
                    </p>
                    <p style={{ fontSize: 12 }}>
                      Credit: {photo.credit || "NN"}
                    </p>
                    <p style={{ fontSize: 12 }}>
                      Number: {photo.number || "NN"}
                    </p>
                    <p style={{ fontSize: 12 }} className="md:col-span-2 truncate">
                      Source:{" "}
                      {photo.sourceUrl ? (
                        <a
                          href={photo.sourceUrl}
                          target="_blank"
                          rel="noreferrer"
                          style={{ color: "inherit", textDecoration: "underline" }}
                        >
                          {photo.sourceUrl}
                        </a>
                      ) : (
                        "-"
                      )}
                    </p>
                  </div>
                </div>
              </div>
              {newTag && <NewTagPhoto x={newTag.x} y={newTag.y} />}
              {showTags &&
                tags.map((tag) => {
                  return (
                    <PhotoTag tag={tag} key={`tag-component-${tag._id}`} />
                  );
                })}
              <img
                src={SingleArrow}
                className={` absolute bottom-20 right-12 ${
                  photoPhosition("first") ? "opacity-0" : ""
                }`}
                role="button"
                onClick={prevPhoto}
              />
              <img
                src={SingleArrow}
                className={` rotate-180 absolute bottom-8 right-12 ${
                  photoPhosition("last") ? "opacity-0" : ""
                }`}
                role="button"
                onClick={nextPhoto}
              />
            </div>
            <div className="actions-container font-sans mt-4">
              <div className="action-container">
                <img
                  src={LikeIcon}
                  onClick={handleLike}
                  id="like-btn"
                  className={liked ? "active" : ""}
                />
                <h4 className="font-extralight">{photo.likes.length}</h4>
              </div>
              <div className="action-container">
                <img
                  src={DislikeIcon}
                  onClick={handleDislike}
                  id="dislike-btn"
                  className={disliked ? "active" : ""}
                />
                <h4 className="font-extralight">{photo.dislikes.length}</h4>
              </div>
              <div className="action-container">
                <img src={CommentIcon} />
                <h4 className="font-extralight">{totalComments}</h4>
              </div>
              <div className="action-container">
                <img src={ViewsIcon} />
                <h4 className="font-extralight">{photo.views}</h4>
              </div>
            </div>
            <div className="dates-info-container font-sans mt-2">
              <div className="c-row">
                <p className="font-bold">
                  {photo.year}:{" "}
                  <span className="font-extralight">
                    {photos[year].findIndex((photo) => photo._id === index) + 1}{" "}
                    of {photos[year].length}
                  </span>
                </p>
              </div>
              <div className="c-row">
                <p className="font-bold">
                  {getPhotoDate(photo.year, photo.month, photo.day)}
                </p>
              </div>
              <div className="c-row">
                <p className="font-extralight">
                  {getDifferenceDateBirth(
                    getPhotoDate(photo.year, photo.month, photo.day),
                    gallery.dateStart,
                  )}
                </p>
              </div>
            </div>
          </>
        )}
      </div>
      <div className="gallery-info-discussion-container">
        <div className="gallery-info-tag-container">
          <div className="gallery-info-container font-sans">
            <div className="c-row">
              <h1
                className="hover:underline font-bold cursor-pointer"
                onClick={() => router.push("/" + gallery.name)}
              >
                {gallery.name}
              </h1>
              {gallery.categories.map((category: string, i: number) => {
                return (
                  <span
                    className="category-tag font-extralight"
                    key={`category-tag-${i}`}
                    role="button"
                    onClick={() => router.push(`/categories/${category}`)}
                  >
                    {category}
                  </span>
                );
              })}
            </div>
            <div className="c-row">
              <h3 className="font-bold">
                Date of birth: {getDateFormat1(gallery.dateStart)}
              </h3>
            </div>
            {gallery.dateEnd && (
              <div className="c-row">
                <h3 className="font-bold">
                  Date of death: {getDateFormat1(gallery.dateEnd)}
                </h3>
              </div>
            )}
            <div className="c-row">
              <h4 className="font-extralight">
                {years.indexOf(year) + 1} of {years.length} Available
              </h4>
            </div>
            <div className="c-row creator">
              <h3 className="font-bold">Creator:</h3>
              {!loadingAuthor ? (
                <ProfileLink className="creator-container" name={author?.name}>
                  {author !== null && (
                    <div className="image-container">
                      <img
                        src={author?.avatar}
                        onError={handleImageError}
                        alt="Creator avatar"
                      />
                    </div>
                  )}
                  <h3 className="font-extralight">
                    {author?.name ||
                      (author === "UNREGISTERED" ? author : "Account deleted")}
                  </h3>
                </ProfileLink>
              ) : (
                <div className="creator-container loading-creator">
                  <div className="image-container"></div>
                  <div className="loading-creator-name"></div>
                </div>
              )}
            </div>
            {currentUser && (currentUser.admin === 1 || currentUser.admin === 2) && (
              <p>Uploaded: {photo && formatDateTime(photo?.createdAt)}</p>
            )}

            <div className="c-row">
              <SubscriptionBtn gallery={gallery} />
              <button className="btn linear-bg" onClick={() => setSubNav(2)}>
                Suggest Edition
              </button>
              <button
                className="btn linear-bg"
                onClick={() =>
                  setReport({
                    show: true,
                    reportedElement: {
                      id: photo!._id,
                      galleryId: gallery._id,
                      type: "photo",
                      url: photo!.url,
                    },
                  })
                }
              >
                Report photo
              </button>
              <button
                className="btn linear-bg"
                onClick={() => setReplace({ show: true, replacePhoto: photo })}
              >
                Replace
              </button>
              {/* moved '+ to collection' to the top container to avoid image overlap */}
            </div>
          </div>
          {tags.length > 0 && (
            <div
              className="tagged-photo-container"
              onMouseEnter={() => setShowTags(true)}
              onMouseLeave={() => setShowTags(false)}
            >
              <h3>Tagged On Photo: {tags.length} People</h3>
              <ol>
                {tags.map((tag, i) => {
                  return (
                    <li
                      key={tag._id}
                      className="d-flex justify-content-between align-items-center mb-1"
                    >
                      <h3
                        className="m-0 font-light fs-3"
                        onClick={() =>
                          router.push("/gallery/" + tag.gallery_id._id)
                        }
                        style={{ cursor: "pointer" }}
                      >
                        {i + 1 + ". "}
                        {tag.gallery_id.name}
                        {tag.userId && " (added by " + tag.userId.name + ")"}
                      </h3>
                      {currentUser && currentUser.admin > 0 && (
                        <button
                          className="btn linear-bg fs-5"
                          onClick={() => handleDeleteTag(tag)}
                          disabled={loadingDeleteTag}
                        >
                          Delete
                        </button>
                      )}
                    </li>
                  );
                })}
              </ol>
            </div>
          )}
        </div>
        <div className="photo-discussion-container">
          <ul className="font-sans">
            <li
              className={`font-bold ${subNav === 0 ? "active" : ""}`}
              onClick={() => setSubNav(0)}
            >
              Details
            </li>
            <li
              className={`font-bold ${subNav === 1 ? "active" : ""}`}
              onClick={() => setSubNav(1)}
            >
              Comments
            </li>
            <li
              className={`font-bold ${subNav === 2 ? "active" : ""}`}
              onClick={() => setSubNav(2)}
            >
              Discussion
            </li>
          </ul>
          <div className="nav-option-outlet">
            {subNav === 0 && <p>{photo?.description}</p>}
            {subNav === 1 && (
              <PhotoComments>
                <NewComment photoId={photo!._id} />
                {comments.map((comment: any) => {
                  return (
                    <Comment
                      setReport={setReport}
                      comment={comment}
                      key={`comment-component-${comment._id}`}
                      viewOnly={
                        !currentUser ||
                        (currentUser &&
                          (currentUser.readOnly || currentUser.isSuspended))
                      }
                    />
                  );
                })}
              </PhotoComments>
            )}
            {subNav === 2 && (
              <PhotoDiscussions>
                <NewDiscussion photoId={photo!._id} />
                {discussions.map((comment: any) => {
                  return (
                    <Discussion
                      setReport={setReport}
                      viewOnly={
                        !currentUser ||
                        (currentUser &&
                          (currentUser.readOnly || currentUser.isSuspended))
                      }
                      discussion={comment}
                      key={`comment-component-${comment._id}`}
                    />
                  );
                })}
              </PhotoDiscussions>
            )}
          </div>
        </div>
      </div>
      {/* Add to collection modal */}
      {photo && (
        <AddToCollectionModal
          open={showAddToCollection}
          onClose={() => setShowAddToCollection(false)}
          photoId={photo._id}
        />
      )}
    </div>
  );
}

export default GalleryYear;
